/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimit200ResponseReissueOneOf1
 */
export interface UpdateDailyUserUsageLimit200ResponseReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseReissueOneOf1
     */
    'cardType': UpdateDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200ResponseReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const UpdateDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type UpdateDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum = typeof UpdateDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum[keyof typeof UpdateDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum];


